<wiz-hgroup height="100%" width="100%" verticalAlign="center" style="padding-left: 5px" gap="0">
  <wiz-hgroup width="150px" height="100%" horizontalAlign="end" class="not-clickable-widget" style="padding: 2px">
    <wiz-label [wizLabel]="data[0]" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
  </wiz-hgroup>
  <wiz-hgroup height="100%" width="100%" horizontalAlign="end" class="not-clickable-widget" style="padding: 2px">
    <wiz-label [wizLabel]="data[1]" width="100%" [wizTextBehavior]="'truncate'"></wiz-label>
  </wiz-hgroup>
</wiz-hgroup>
